// Отвечает ли каталог за воду под точкой (`cabinet_rules.rules_coverage`) и
// на каком языке цитата нормы.
//
// Аудит 20.10.2026: точка вне воды каталога получала нормы выбранного бассейна —
// клик в Баренцевом море или у Хоккайдо показывал приказ № 285 с «действует».
// Теперь сервер отвечает пустым списком и причиной, а витрина называет её
// словами: пустой список без слов читался бы как «здесь ничего не запрещено».

import { t } from '../i18n'
import type { Lang } from '../i18n'
import { zoneLine, type ZoneAnswer } from '../map/eez'

export interface RulesCoverage {
  status: 'supported' | 'not_supported'
  reason?: 'outside_basins' | 'foreign_eez'
  zone?: ZoneAnswer | null
}

/** Строка о воде вне каталога; `null` — каталог за эту воду отвечает. */
export function coverageNote(c: RulesCoverage | null | undefined): string | null {
  if (!c || c.status === 'supported') return null
  const zone = zoneLine(c.zone)
  if (c.reason === 'foreign_eez' && zone) return t('rules.coverage.foreign', { zone })
  return zone ? t('rules.coverage.outsideZone', { zone }) : t('rules.coverage.outside')
}

/** Подпись над цитатой. Язык документа — данные ответа (`quote_lang`), а не
 *  догадка витрины: у приказа № 285 он русский, у правил Омана английский. */
export function quoteLabel(quoteLang: string | null | undefined, ui: Lang,
  origLang?: string | null): string {
  const name = (code: string) => {
    try {
      return new Intl.DisplayNames([ui], { type: 'language' }).of(code) ?? code
    } catch { return code /* старый браузер — код языка как есть */ }
  }
  // Цитата — перевод (Оман: английский перевод проекта с арабского). Выдать
  // его за оригинал значило бы приписать акту слова, которых в нём нет.
  if (quoteLang && origLang && quoteLang !== origLang) {
    return t('rules.quoteTranslation', { lang: name(quoteLang), orig: name(origLang) })
  }
  if (!quoteLang || quoteLang === ui) return t('rules.quote')
  return t('rules.quoteOriginal', { lang: name(quoteLang) })
}
